let MediaTranscoder = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.form();
        this.replaysForm();
    },

    form: function () {
        let _this = this;
        const form = $('#mediaTranscoderForm');

        if (form.length) {
            let submitBtn = Ladda.create(form.find('[type=submit]')[0]);

            form.ajaxForm({
                beforeSubmit: function () {
                    $('.form-group').removeClass('has-error');
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        toastr.success(response.message);
                        setTimeout(() => {
                            window.location.assign('/media-transcoder');
                        }, 1000);
                    } else {
                        submitBtn.stop();
                        toastr.error(response.message);
                    }
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });
        }
    },
    replaysForm: function () {
        let _this = this;
        const form = $('#mediaTranscoderReplaysForm');

        if (form.length) {
            let submitBtn = Ladda.create(form.find('[type=submit]')[0]);

            form.ajaxForm({
                beforeSubmit: function () {
                    $('.form-group').removeClass('has-error');
                    submitBtn.start();
                },
                success: function (response) {
                    if (response.success) {
                        toastr.success(response.message);
                        setTimeout(() => {
                            window.location.assign('/media-transcoder');
                        }, 1000);
                    } else {
                        submitBtn.stop();
                        toastr.error(response.message);
                    }
                },
                error: function (err) {
                    submitBtn.stop();

                    let error = err.responseJSON;

                    if (error.errors) {
                        toastr.error(Object.values(error.errors).join('<br>')).css("width", "500px");
                        Object.keys(error.errors).forEach(field => {
                            $('[name=' + field + ']').closest('.form-group').addClass('has-error');
                        });
                    } else {
                        toastr.error(error.message);
                    }

                }
            });
        }
    },
};

$().ready(function () {
    window.MediaTranscoder = MediaTranscoder;
    window.MediaTranscoder.init();
});
